import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "readonly-component" }
const _hoisted_2 = { class: "form-title" }
const _hoisted_3 = { class: "form-value" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadOnlyCompornent',
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    title: {
      type: String,
    }
  },
  setup(__props) {


  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.readOnly)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(props.title), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(props.value), 1)
        ], 64))
      : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
  ]))
}
}

})